module.exports = __webpack_public_path__ + "static/media/24UHCHR25.2be5b916.jpg";